import { useSliderLayout } from '../hooks/useSliderLayout';

type SliderLayoutContainerProps = { children: React.ReactNode; fullWidth: any; arrowSize: any };

const SliderLayoutContainer = ({ children, fullWidth, arrowSize }: SliderLayoutContainerProps) => {
	const { blockClass, componentId } = useSliderLayout();

	return (
		<section
			data-selection={componentId}
			style={{
				paddingLeft: fullWidth ? undefined : arrowSize * 2,
				paddingRight: fullWidth ? undefined : arrowSize * 2,
			}}
			aria-label="slider"
			className={`sliderLayoutContainer sliderLayoutContainer--${blockClass} w-100 flex items-center relative vtex-slider-layout-0-x-sliderLayoutContainer vtex-slider-layout-0-x-sliderLayoutContainer--${blockClass}`}
		>
			{children}
		</section>
	);
};

export default SliderLayoutContainer;
